/* eslint-disable no-unused-vars  */
/* eslint-disable no-undef */
export default function() {
  const x = new MutationObserver(e => {
    [...e].forEach(mutationRecord => {
      if (mutationRecord.addedNodes && mutationRecord.addedNodes.length > 0) {
        if (mutationRecord.addedNodes[0].classList) {
          const element = mutationRecord.addedNodes[0];

          if (element.getAttribute('id') === 'stamped-script-widget') {
            const stampedWidget = document.querySelector('.stamped-main-widget');
            if (stampedWidget) {
              if (stampedWidget.length) {
                const reviewsTitle = stampedWidget.querySelector('.stamped-header-title');
                const basedOn = stampedWidget.querySelector('.stamped-summary-text');
                const writeReviewButton = stampedWidget.querySelector(
                  '.stamped-summary-actions-newreview',
                );
                const emptyState = stampedWidget.querySelector('.stamped-empty-state div');
                const nameLabel = stampedWidget.querySelector(
                  '.stamped-form-contact-name .stamped-form-label',
                );
                const nameInput = stampedWidget.querySelector(
                  '.stamped-form-contact-name .stamped-form-input',
                );
                const emailLabel = stampedWidget.querySelector(
                  '.stamped-form-contact-email .stamped-form-label',
                );
                const emailInput = stampedWidget.querySelector(
                  '.stamped-form-contact-email .stamped-form-input',
                );

                const reviewLabel = stampedWidget.querySelector(
                  '.stamped-form-review-rating .stamped-form-label',
                );
                const reviewTitleLabel = stampedWidget.querySelector(
                  '.stamped-form-review-title .stamped-form-label',
                );
                const reviewTitleInput = stampedWidget.querySelector(
                  '.stamped-form-review-title .stamped-form-input',
                );
                const messageLabel = stampedWidget.querySelector(
                  '.stamped-form-review-body .stamped-form-label',
                );
                const fileUploadLabel = stampedWidget.querySelector(
                  '.stamped-file-uploader-btn span',
                );
                const submitButton = stampedWidget.querySelector('#stamped-button-submit');

                if (reviewsTitle && theme.strings.stampedio_title) {
                  reviewsTitle.innerText = theme.strings.stampedio_title;
                }
                if (basedOn && theme.strings.stampedio_based_on) {
                  const { count } = basedOn.dataset;
                  const includingCount = theme.strings.stampedio_based_on.replace(
                    '{{count}}',
                    count,
                  );
                  basedOn.innerText = includingCount;
                }
                if (writeReviewButton && theme.strings.stampedio_write_review) {
                  writeReviewButton.innerText = theme.strings.stampedio_write_review;
                }
                if (emptyState && theme.strings.stampedio_no_reviews_yet) {
                  emptyState.innerText = theme.strings.stampedio_no_reviews_yet;
                }
                if (nameLabel && theme.strings.stampedio_name_label) {
                  nameLabel.innerText = theme.strings.stampedio_name_label;
                }
                if (nameInput && theme.strings.stampedio_name_placeholder) {
                  nameInput.placeholder = theme.strings.stampedio_name_placeholder;
                }
                if (emailLabel && theme.strings.stampedio_email_label) {
                  emailLabel.innerText = theme.strings.stampedio_email_label;
                }
                if (emailInput && theme.strings.stampedio_email_placeholder) {
                  emailInput.placeholder = theme.strings.stampedio_email_placeholder;
                }
                if (reviewLabel && theme.strings.stampedio_rating_label) {
                  reviewLabel.innerText = theme.strings.stampedio_rating_label;
                }
                if (reviewTitleLabel && theme.strings.stampedio_review_title_label) {
                  reviewTitleLabel.innerText = theme.strings.stampedio_review_title_label;
                }
                if (reviewTitleInput && theme.strings.stampedio_review_title_placeholder) {
                  reviewTitleInput.placeholder = theme.strings.stampedio_review_title_placeholder;
                }
                if (messageLabel && theme.strings.stampedio_title) {
                  messageLabel.innerText = theme.strings.stampedio_title;
                }
                // before el
                /*     if (fileUploadLabel && theme.strings.stampedio_add_photo_label) {
                  fileUploadLabel.innerText = theme.strings.stampedio_add_photo_label;
                } */
                if (submitButton && theme.strings.stampedio_submit) {
                  submitButton.value = theme.strings.stampedio_submit;
                }
              }
            }
          }
        }
      }
    });
  });

  x.observe(document.body, { childList: true });
}
